import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { I18nContextProvider, I18nInstanceType } from '@ecg-marktplaats/js-react-i18n';
import { Header } from '@hz-design-system/web-ui';
import PurchaseBundleApp from '../../apps/PurchaseBundle/PurchaseBundle';

import '../../../scss/site/global/global.scss';
import '../../../scss/site/pages/PurchaseBundle/PurchaseBundle.scss';

export default (i18n: I18nInstanceType) => {
  const appState = window.__CONFIG__ || {};
  const environment = window.__ENV_CONFIG__ || {};
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const rootContainer = document.getElementById('root');
  const headerRootContainer = document.getElementById('header-root');

  // Header is server side rendered in express-react library
  // todo: Add I18nContext wrapper here and in express-react as well
  hydrateRoot(headerRootContainer as HTMLElement, <Header headerConfig={headerConfig} />);

  hydrateRoot(
    rootContainer as HTMLElement,
    <I18nContextProvider i18nInstance={i18n}>
      <PurchaseBundleApp appState={appState} environment={environment} />
    </I18nContextProvider>,
  );
};
